<template>
    <div class="no-auth-modal">
        <el-alert title="无该项目权限，请联系上级负责人在【媒体账户绑定】进行账户授权，拥有投放的账户权限后即可使用该项目" type="error" :closable=false>
        </el-alert>
        <!-- <h5 style="padding: 12px 0 8px 0px">可赋予权限得账户列表</h5> -->
        <div style="max-height: 50vh;overflow-y: auto;">
            <h5 style="padding: 12px 0 8px 0px" v-if="getToplist && getToplist.length != 0">可赋予权限的账户列表</h5>
            <div v-for="(item, index) in getToplist" :key="index">
                <h5 style="padding-top: 8px;">产品名称：{{item.project_name}}</h5>
                <ul>
                    <li v-for="(ele, i) in item.error_msg" :key="i">{{ele}}</li>
                </ul>
            </div>
            <div style="height: 16px;" v-if="getSubList && getSubList.length != 0"></div>
            <div v-for="(item, index) in getSubList" :key="index">
                <h5 style="padding-top: 8px;">产品名称：{{item.project_name}}</h5>
                <ul>
                    <li v-for="(ele, i) in item.error_msg" :key="i">{{ele}}</li>
                </ul>
            </div>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="primary" @click="toAccountPage" class="action-btn ml10 mr10">立即前往维护</el-button>
            <el-button type="primary" @click="copyData" class="action-btn ml10 mr10">复制账户ID</el-button>
            <el-button type="default" @click="hideModal" class="action-btn ml10 mr10">关闭</el-button>
        </p>
    </div>
</template>
<script>

import utils from '@/libs/utils.js';
import {Message} from "element-ui";
export default {
    name: "noAuthModal",
    props: {
        cbs: {
            type: Object,
        },
        list: Array,
    },
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        getToplist() {
            return this.list && this.list.filter(item => item.error_type == '2');
        },
        getSubList() {
            return this.list && this.list.filter(item => item.error_type == '1');
        }
    },
    methods: {
        hideModal() {
            // this.$emit('close');
            this.cbs.onClose();
        },
        toAccountPage(){
            let idList = this.getAccountIds();
            console.log('toAccountPage',idList);
            this.cbs.toAccountPage(idList);
        },
        copyData(){
            let idList = this.getAccountIds();
            let copyTxt = idList.join('\r\n');
            console.log('复制', copyTxt)
            utils.setClipboardText(copyTxt);
            this.$message.success('复制成功');
        },
        getAccountIds(){
            let list = [];
            const regex = /账户ID：([^；]+)/;
            this.list.forEach(item=>{
                let errorMsg = item.error_msg;
                if(Array.isArray(errorMsg)&&errorMsg.length>0){
                    errorMsg.forEach(inner=>{
                        const match = inner.match(regex);
                        if (match) {
                            list.push(match[1]);
                        }
                    })
                }
            })
            return list;
        },
    },
}
</script>
<style lang="scss" scoped>
.no-auth-modal {
    li {
        padding: 6px 0;
        font-size: 12px;
    }
}
</style>
